




























































import { Component, ModelSync, Prop, Vue } from "vue-property-decorator"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { TYPES as BOOKING_TYPES } from "@/constants/booking"
import QShareCode from "@/components/QShareCode.vue"

@Component({
  components: {
    QShareCode
  }
})
export default class BookingListCandidatesDrawer extends Vue {
  @ModelSync("show", "change") readonly showCandidateListDrawer!: boolean
  @Prop() readonly booking!: any

  bookingTypes = BOOKING_TYPES
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES

  search = ""

  get candidateTableHeaders() {
    return [
      {
        text: "Candidate",
        value: "candidate",
      },
      {
        text: "Share Code",
        value: "share_code",
      },
      {
        text: "Status",
        value: "status",
      },
    ]
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          "first_name",
          "last_name",
          "date_of_birth",
          "mobile",
          "email",
        ].includes(k) && item[k].toString().toLowerCase().includes(search)
      )
    })
  }
}
